import config from '../config';
const API_URL = config.dexfApiUrl;
const DEXF_API_KEY = config.dexfApiKey;
/**
 * Fetch DEXF products given a list of article types (ART, SPR etc.) and id:s.
 * @param items The article id:s for which to fetch products.
 * @returns An array of products from DEXF
 */
export const getDexfProducts = async (items) => {
    return await fetch(`${API_URL}?filter.itemId=${items.map(p => `${p.type}-${p.id}`).join(',')}`, {
        headers: {
            accept: 'application/json',
            'DEXF-API-KEY': DEXF_API_KEY
        }
    }).then(async (r) => (await r.json()).data);
};
//# sourceMappingURL=dexf.js.map